var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import AccurityIcon from '../../icon/components/AccurityIcon';
import { Collapse } from '@mui/material';
import { createReactTooltip } from '../../common/tooltip';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
var CollapsingGroup = function (_a) {
    var name = _a.name, title = _a.title, icon = _a.icon, _b = _a.iconSize, iconSize = _b === void 0 ? 'medium' : _b, expandedByDefault = _a.expandedByDefault, expandable = _a.expandable, expandDisabled = _a.expandDisabled, tooltip = _a.tooltip, customHeader = _a.customHeader, onEditClick = _a.onEditClick, onAddClick = _a.onAddClick, disabled = _a.disabled, inverted = _a.inverted, children = _a.children, showInheritanceBadge = _a.showInheritanceBadge, objectTypeLabel = _a.objectTypeLabel;
    var _c = React.useState(expandedByDefault), expanded = _c[0], setExpanded = _c[1];
    var handleExpandClick = function () {
        setExpanded(!expanded);
    };
    var _d = createReactTooltip(tooltip, 'collapsingGroup-' + name), tooltipElement = _d.tooltipElement, tooltipAnchorParams = _d.tooltipAnchorParams;
    var header = customHeader ? customHeader : (React.createElement("div", __assign({ className: 'collapsingGroup__iconAndTitle' }, tooltipAnchorParams),
        icon && React.createElement(AccurityIcon, { iconName: icon, fontSize: iconSize }),
        React.createElement("span", null, title)));
    var headerButton;
    if (onEditClick) {
        headerButton = (React.createElement(AccurityIconButton, { onClick: onEditClick, iconName: "mui:EditOutlined", disabled: disabled, title: objectTypeLabel ? "Edit " + objectTypeLabel : '' }));
    }
    else if (onAddClick) {
        headerButton = (React.createElement(AccurityIconButton, { onClick: onAddClick, iconName: "mui:Add", disabled: disabled, title: objectTypeLabel ? "Create new " + objectTypeLabel : '' }));
    }
    return (React.createElement("div", { className: 'collapsingGroup', "data-field-name": name },
        React.createElement("div", { className: classNames('collapsingGroup__header', { 'collapsingGroup__header--customHeader': customHeader }), onClick: customHeader ? undefined : handleExpandClick },
            header,
            headerButton,
            showInheritanceBadge && React.createElement(AccurityIcon, { iconName: "mui:LayersOutlined", color: "secondary700" }),
            expandable && (React.createElement(AccurityIconButton, { className: 'collapsingGroup__expandIcon', onClick: customHeader ? handleExpandClick : undefined, iconName: expanded ? 'mui:ExpandLess' : 'mui:ExpandMore', disabled: expandDisabled, "aria-expanded": expanded }))),
        React.createElement(Collapse, { in: expanded, timeout: 0, className: classNames('collapsingGroup__body', { 'collapsingGroup__body--inverted': inverted }) }, children),
        tooltipElement));
};
export default CollapsingGroup;
//# sourceMappingURL=CollapsingGroup.js.map